import React from 'react'

export default function RobinturMail ({ documentType, code }) {
  const getBtnSign = (type, code) => {
    if (type === 'REMOTE' && code) {
      return (
        <table
          className='mcnButtonBlock'
          style={{
            minWidth: '100%',
            borderCollapse: 'collapse',
            msoTableLspace: '0pt',
            msoTableRspace: '0pt',
            msTextSizeAdjust: '100%',
            WebkitTextSizeAdjust: '100%'
          }}
          width='100%'
          cellSpacing={0}
          cellPadding={0}
          border={0}
        >
          <tbody className='mcnButtonBlockOuter'>
            <tr>
              <td
                style={{
                  paddingTop: 0,
                  paddingRight: '18px',
                  paddingBottom: '18px',
                  paddingLeft: '18px',
                  msoLineHeightRule: 'exactly',
                  msTextSizeAdjust: '100%',
                  WebkitTextSizeAdjust: '100%'
                }}
                className='mcnButtonBlockInner'
                valign='top'
                align='center'
              >
                <table
                  className='mcnButtonContentContainer'
                  style={{
                    borderCollapse: 'separate !important',
                    borderRadius: '50px',
                    backgroundColor: '#EC4541',
                    msoTableLspace: '0pt',
                    msoTableRspace: '0pt',
                    msTextSizeAdjust: '100%',
                    WebkitTextSizeAdjust: '100%'
                  }}
                  cellSpacing={0}
                  cellPadding={0}
                  border={0}
                >
                  <tbody>
                    <tr>
                      <td
                        className='mcnButtonContent'
                        style={{
                          fontFamily: '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif',
                          fontSize: '16px',
                          padding: '18px',
                          msoLineHeightRule: 'exactly',
                          msTextSizeAdjust: '100%',
                          WebkitTextSizeAdjust: '100%'
                        }}
                        valign='middle'
                        align='center'
                      >
                        <a
                          className='mcnButton '
                          title='Firma il documento'
                          href={`https://firmadoc.robintur.it/${code}`}
                          target='_blank'
                          rel='noopener noreferrer'
                          style={{
                            fontWeight: 'normal',
                            letterSpacing: 'normal',
                            lineHeight: '100%',
                            textAlign: 'center',
                            textDecoration: 'none',
                            color: '#FFFFFF',
                            msoLineHeightRule: 'exactly',
                            msTextSizeAdjust: '100%',
                            WebkitTextSizeAdjust: '100%',
                            display: 'block'
                          }}
                        >
                          Firma il documento
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      )
    }
  }

  const getDocumentLabel = (type, code) => {
    if (type === 'CON') return 'la copia del tuo contratto firmato.'
    if (type === 'PRI') return 'la copia dell\'informativa privacy firmata.'
    if (type === 'REMOTE') {
      const link = `https://firmadoc.robintur.it/${code}`
      return (
        <div>
          il{' '}
          <a
            href={link}
            target='_blank'
            rel='noopener noreferrer'
            style={{
              msoLineHeightRule: 'exactly',
              msTextSizeAdjust: '100%',
              WebkitTextSizeAdjust: '100%',
              color: '#007C89',
              fontWeight: 'normal',
              textDecoration: 'underline'
            }}
          >
            link
          </a>{' '}
          per effettuare la firma di un documento da remoto.
        </div>
      )
    }
  }
  return (
    <div>
      <link rel='important stylesheet' href='chrome://messagebody/skin/messageBody.css' />
      {/* NAME: 1 COLUMN - FULL WIDTH */}
      {/* [if gte mso 15]>
  <xml>
      <o:OfficeDocumentSettings>
      <o:AllowPNG/>
      <o:PixelsPerInch>96</o:PixelsPerInch>
      </o:OfficeDocumentSettings>
  </xml>
  <![endif] */}
      <meta charSet='UTF-8' />
      <meta httpEquiv='X-UA-Compatible' content='IE=edge' />
      <meta name='viewport' content='width=device-width, initial-scale=1' />
      <style
        type='text/css'
        dangerouslySetInnerHTML={{
          __html:
            '\np{\nmargin:10px 0;\npadding:0;\n  }\n  table{\n    border-collapse:collapse;\n  }\n  h1,h2,h3,h4,h5,h6{\n    display:block;\n    margin:0;\n    padding:0;\n  }\n  img,a img{\n    border:0;\n    height:auto;\n    outline:none;\n    text-decoration:none;\n  }\n  body,#bodyTable,#bodyCell{\n    height:100%;\n    margin:0;\n    padding:0;\n    width:100%;\n  }\n  .mcnPreviewText{\n    display:none !important;\n  }\n  #outlook a{\n    padding:0;\n  }\n  img{\n    -ms-interpolation-mode:bicubic;\n  }\n  table{\n    mso-table-lspace:0pt;\n    mso-table-rspace:0pt;\n  }\n  .ReadMsgBody{\n    width:100%;\n  }\n  .ExternalClass{\n    width:100%;\n  }\n  p,a,li,td,blockquote{\n    mso-line-height-rule:exactly;\n  }\n  a[href^=tel],a[href^=sms]{\n    color:inherit;\n    cursor:default;\n    text-decoration:none;\n  }\n  p,a,li,td,body,table,blockquote{\n    -ms-text-size-adjust:100%;\n    -webkit-text-size-adjust:100%;\n  }\n  .ExternalClass,.ExternalClass p,.ExternalClass td,.ExternalClass div,.ExternalClass span,.ExternalClass font{\n    line-height:100%;\n  }\n  a[x-apple-data-detectors]{\n    color:inherit !important;\n    text-decoration:none !important;\n    font-size:inherit !important;\n    font-family:inherit !important;\n    font-weight:inherit !important;\n    line-height:inherit !important;\n  }\n  .templateContainer{\n    max-width:600px !important;\n  }\n  a.mcnButton{\n    display:block;\n  }\n  .mcnImage,.mcnRetinaImage{\n    vertical-align:bottom;\n  }\n  .mcnTextContent{\n    word-break:break-word;\n  }\n  .mcnTextContent img{\n    height:auto !important;\n  }\n  .mcnDividerBlock{\n    table-layout:fixed !important;\n  }\n  body,#bodyTable{\n    background-color:#ffffff;\n  }\n  #bodyCell{\n    border-top:0;\n  }\n  h1{\n    color:#51536b;\n    font-family:\'Roboto\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    font-size:36px;\n    font-style:normal;\n    font-weight:bold;\n    line-height:125%;\n    letter-spacing:normal;\n    text-align:left;\n  }\n  h2{\n    color:#51536b;\n    font-family:\'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    font-size:20px;\n    font-style:normal;\n    font-weight:normal;\n    line-height:150%;\n    letter-spacing:1px;\n    text-align:center;\n  }\n  h3{\n    color:#ec4541;\n    font-family:Helvetica;\n    font-size:20px;\n    font-style:normal;\n    font-weight:bold;\n    line-height:125%;\n    letter-spacing:normal;\n    text-align:left;\n  }\n  h4{\n    color:#202020;\n    font-family:Helvetica;\n    font-size:18px;\n    font-style:normal;\n    font-weight:bold;\n    line-height:125%;\n    letter-spacing:normal;\n    text-align:left;\n  }\n  #templatePreheader{\n    background-color:#fafafa;\n    background-image:none;\n    background-repeat:no-repeat;\n    background-position:center;\n    background-size:cover;\n    border-top:0;\n    border-bottom:0;\n    padding-top:9px;\n    padding-bottom:9px;\n  }\n  #templatePreheader .mcnTextContent,#templatePreheader .mcnTextContent p{\n    color:#656565;\n    font-family:Helvetica;\n    font-size:12px;\n    line-height:150%;\n    text-align:left;\n  }\n  #templatePreheader .mcnTextContent a,#templatePreheader .mcnTextContent p a{\n    color:#656565;\n    font-weight:normal;\n    text-decoration:underline;\n  }\n  #templateHeader{\n    background-color:#ffffff;\n    background-image:none;\n    background-repeat:no-repeat;\n    background-position:center;\n    background-size:cover;\n    border-top:0;\n    border-bottom:0;\n    padding-top:9px;\n    padding-bottom:0;\n  }\n  #templateHeader .mcnTextContent,#templateHeader .mcnTextContent p{\n    color:#202020;\n    font-family:Helvetica;\n    font-size:16px;\n    line-height:150%;\n    text-align:left;\n  }\n  #templateHeader .mcnTextContent a,#templateHeader .mcnTextContent p a{\n    color:#007C89;\n    font-weight:normal;\n    text-decoration:underline;\n  }\n  #templateBody{\n    background-color:#e5edf6;\n    background-image:none;\n    background-repeat:no-repeat;\n    background-position:center;\n    background-size:cover;\n    border-top:0;\n    border-bottom:0;\n    padding-top:9px;\n    padding-bottom:9px;\n  }\n  #templateBody .mcnTextContent,#templateBody .mcnTextContent p{\n    color:#494949;\n    font-family:\'Open Sans\', \'Helvetica Neue\', Helvetica, Arial, sans-serif;\n    font-size:16px;\n    line-height:150%;\n    text-align:left;\n  }\n  #templateBody .mcnTextContent a,#templateBody .mcnTextContent p a{\n    color:#007C89;\n    font-weight:normal;\n    text-decoration:underline;\n  }\n  #templateFooter{\n    background-color:#51536b;\n    background-image:none;\n    background-repeat:no-repeat;\n    background-position:center;\n    background-size:cover;\n    border-top:0;\n    border-bottom:0;\n    padding-top:9px;\n    padding-bottom:9px;\n  }\n  #templateFooter .mcnTextContent,#templateFooter .mcnTextContent p{\n    color:#ffffff;\n    font-family:Helvetica;\n    font-size:12px;\n    line-height:150%;\n    text-align:center;\n  }\n  #templateFooter .mcnTextContent a,#templateFooter .mcnTextContent p a{\n    color:#ec4541;\n    font-weight:normal;\n    text-decoration:underline;\n  }\n@media only screen and (min-width:768px){\n  .templateContainer{\n    width:600px !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  body,table,td,p,a,li,blockquote{\n    -webkit-text-size-adjust:none !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  body{\n    width:100% !important;\n    min-width:100% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnRetinaImage{\n    max-width:100% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnImage{\n    width:100% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnCartContainer,.mcnCaptionTopContent,.mcnRecContentContainer,.mcnCaptionBottomContent,.mcnTextContentContainer,.mcnBoxedTextContentContainer,.mcnImageGroupContentContainer,.mcnCaptionLeftTextContentContainer,.mcnCaptionRightTextContentContainer,.mcnCaptionLeftImageContentContainer,.mcnCaptionRightImageContentContainer,.mcnImageCardLeftTextContentContainer,.mcnImageCardRightTextContentContainer,.mcnImageCardLeftImageContentContainer,.mcnImageCardRightImageContentContainer{\n    max-width:100% !important;\n    width:100% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnBoxedTextContentContainer{\n    min-width:100% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnImageGroupContent{\n    padding:9px !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnCaptionLeftContentOuter .mcnTextContent,.mcnCaptionRightContentOuter .mcnTextContent{\n    padding-top:9px !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnImageCardTopImageContent,.mcnCaptionBottomContent:last-child .mcnCaptionBottomImageContent,.mcnCaptionBlockInner .mcnCaptionTopContent:last-child .mcnTextContent{\n    padding-top:18px !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnImageCardBottomImageContent{\n    padding-bottom:9px !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnImageGroupBlockInner{\n    padding-top:0 !important;\n    padding-bottom:0 !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnImageGroupBlockOuter{\n    padding-top:9px !important;\n    padding-bottom:9px !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnTextContent,.mcnBoxedTextContentColumn{\n    padding-right:18px !important;\n    padding-left:18px !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnImageCardLeftImageContent,.mcnImageCardRightImageContent{\n    padding-right:18px !important;\n    padding-bottom:0 !important;\n    padding-left:18px !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcpreview-image-uploader{\n    display:none !important;\n    width:100% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  h1{\n    font-size:22px !important;\n    line-height:125% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  h2{\n    font-size:20px !important;\n    line-height:125% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  h3{\n    font-size:18px !important;\n    line-height:125% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  h4{\n    font-size:16px !important;\n    line-height:150% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  .mcnBoxedTextContentContainer .mcnTextContent,.mcnBoxedTextContentContainer .mcnTextContent p{\n    font-size:14px !important;\n    line-height:150% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  #templatePreheader{\n    display:block !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  #templatePreheader .mcnTextContent,#templatePreheader .mcnTextContent p{\n    font-size:14px !important;\n    line-height:150% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  #templateHeader .mcnTextContent,#templateHeader .mcnTextContent p{\n    font-size:16px !important;\n    line-height:150% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  #templateBody .mcnTextContent,#templateBody .mcnTextContent p{\n    font-size:16px !important;\n    line-height:150% !important;\n  }\n\n}@media only screen and (max-width: 480px){\n  #templateFooter .mcnTextContent,#templateFooter .mcnTextContent p{\n    font-size:14px !important;\n    line-height:150% !important;\n  }\n\n}'
        }}
      />
      {/* [if !mso]><! */}
      <link
        href='https://fonts.googleapis.com/css?family=Open+Sans:400,400i,700,700i|Roboto:400,400i,700,700i'
        rel='stylesheet'
      />
      {/* <![endif] */}
      {/*
       */}
      {/* [if !gte mso 9]><!-- */}
      <span
        className='mcnPreviewText'
        style={{
          display: 'none',
          fontSize: '0px',
          lineHeight: '0px',
          maxHeight: '0px',
          maxWidth: '0px',
          opacity: 0,
          overflow: 'hidden',
          visibility: 'hidden',
          msoHide: 'all'
        }}
      >
        Ti auguriamo buone vacanze!
      </span>
      {/* <![endif] */}
      {/*
       */}
      <center>
        <table
          align='center'
          border={0}
          cellPadding={0}
          cellSpacing={0}
          height='100%'
          width='100%'
          id='bodyTable'
          style={{
            borderCollapse: 'collapse',
            msoTableLspace: '0pt',
            msoTableRspace: '0pt',
            msTextSizeAdjust: '100%',
            WebkitTextSizeAdjust: '100%',
            height: '100%',
            margin: 0,
            padding: 0,
            width: '100%',
            backgroundColor: '#ffffff'
          }}
        >
          <tbody>
            <tr>
              <td
                align='center'
                valign='top'
                id='bodyCell'
                style={{
                  msoLineHeightRule: 'exactly',
                  msTextSizeAdjust: '100%',
                  WebkitTextSizeAdjust: '100%',
                  height: '100%',
                  margin: 0,
                  padding: 0,
                  width: '100%',
                  borderTop: 0
                }}
              >
                {/* BEGIN TEMPLATE // */}
                <table
                  border={0}
                  cellPadding={0}
                  cellSpacing={0}
                  width='100%'
                  style={{
                    borderCollapse: 'collapse',
                    msoTableLspace: '0pt',
                    msoTableRspace: '0pt',
                    msTextSizeAdjust: '100%',
                    WebkitTextSizeAdjust: '100%'
                  }}
                >
                  <tbody>
                    <tr>
                      <td
                        align='center'
                        valign='top'
                        id='templatePreheader'
                        style={{
                          background: '#fafafa none no-repeat center/cover',
                          msoLineHeightRule: 'exactly',
                          msTextSizeAdjust: '100%',
                          WebkitTextSizeAdjust: '100%',
                          backgroundColor: '#fafafa',
                          backgroundImage: 'none',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                          backgroundSize: 'cover',
                          borderTop: 0,
                          borderBottom: 0,
                          paddingTop: '9px',
                          paddingBottom: '9px'
                        }}
                      >
                        {/* [if (gte mso 9)|(IE)]>
                              <table align="center"
                              border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">
                              <tr>
                              <td align="center" valign="top" width="600" style="width:600px;">
                              <![endif] */}
                        <table
                          align='center'
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width='100%'
                          className='templateContainer'
                          style={{
                            borderCollapse: 'collapse',
                            msoTableLspace: '0pt',
                            msoTableRspace: '0pt',
                            msTextSizeAdjust: '100%',
                            WebkitTextSizeAdjust: '100%',
                            maxWidth: '600px !important'
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                valign='top'
                                className='preheaderContainer'
                                style={{
                                  msoLineHeightRule: 'exactly',
                                  msTextSizeAdjust: '100%',
                                  WebkitTextSizeAdjust: '100%'
                                }}
                              >
                                <table
                                  className='mcnTextBlock'
                                  style={{
                                    minWidth: '100%',
                                    borderCollapse: 'collapse',
                                    msoTableLspace: '0pt',
                                    msoTableRspace: '0pt',
                                    msTextSizeAdjust: '100%',
                                    WebkitTextSizeAdjust: '100%'
                                  }}
                                  width='100%'
                                  cellSpacing={0}
                                  cellPadding={0}
                                  border={0}
                                >
                                  <tbody className='mcnTextBlockOuter'>
                                    <tr>
                                      <td
                                        className='mcnTextBlockInner'
                                        style={{
                                          paddingTop: '9px',
                                          msoLineHeightRule: 'exactly',
                                          msTextSizeAdjust: '100%',
                                          WebkitTextSizeAdjust: '100%'
                                        }}
                                        valign='top'
                                      >
                                        {/* [if mso]>
  <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
  <tr>
  <![endif] */}
                                        {/* [if mso]>
  <td valign="top" width="600" style="width:600px;">
  <![endif] */}

                                        {/* [if mso]>
  </td>
  <![endif] */}
                                        {/* [if mso]>
  </tr>
  </table>
  <![endif] */}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        {/* [if (gte mso 9)|(IE)]>
                              </td>
                              </tr>
                              </table>
                              <![endif] */}
                      </td>
                    </tr>
                    <tr>
                      <td
                        align='center'
                        valign='top'
                        id='templateHeader'
                        style={{
                          background: '#ffffff none no-repeat center/cover',
                          msoLineHeightRule: 'exactly',
                          msTextSizeAdjust: '100%',
                          WebkitTextSizeAdjust: '100%',
                          backgroundColor: '#ffffff',
                          backgroundImage: 'none',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                          backgroundSize: 'cover',
                          borderTop: 0,
                          borderBottom: 0,
                          paddingTop: '9px',
                          paddingBottom: 0
                        }}
                      >
                        {/* [if (gte mso 9)|(IE)]>
                              <table align="center"
                              border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">
                              <tr>
                              <td align="center" valign="top" width="600" style="width:600px;">
                              <![endif] */}
                        <table
                          align='center'
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width='100%'
                          className='templateContainer'
                          style={{
                            borderCollapse: 'collapse',
                            msoTableLspace: '0pt',
                            msoTableRspace: '0pt',
                            msTextSizeAdjust: '100%',
                            WebkitTextSizeAdjust: '100%',
                            maxWidth: '600px !important'
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                valign='top'
                                className='headerContainer'
                                style={{
                                  msoLineHeightRule: 'exactly',
                                  msTextSizeAdjust: '100%',
                                  WebkitTextSizeAdjust: '100%'
                                }}
                              >
                                <table
                                  className='mcnImageBlock'
                                  style={{
                                    minWidth: '100%',
                                    borderCollapse: 'collapse',
                                    msoTableLspace: '0pt',
                                    msoTableRspace: '0pt',
                                    msTextSizeAdjust: '100%',
                                    WebkitTextSizeAdjust: '100%'
                                  }}
                                  width='100%'
                                  cellSpacing={0}
                                  cellPadding={0}
                                  border={0}
                                >
                                  <tbody className='mcnImageBlockOuter'>
                                    <tr>
                                      <td
                                        style={{
                                          padding: '0px',
                                          msoLineHeightRule: 'exactly',
                                          msTextSizeAdjust: '100%',
                                          WebkitTextSizeAdjust: '100%'
                                        }}
                                        className='mcnImageBlockInner'
                                        valign='top'
                                      >
                                        <table
                                          className='mcnImageContentContainer'
                                          style={{
                                            minWidth: '100%',
                                            borderCollapse: 'collapse',
                                            msoTableLspace: '0pt',
                                            msoTableRspace: '0pt',
                                            msTextSizeAdjust: '100%',
                                            WebkitTextSizeAdjust: '100%'
                                          }}
                                          width='100%'
                                          cellSpacing={0}
                                          cellPadding={0}
                                          border={0}
                                          align='left'
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                className='mcnImageContent'
                                                style={{
                                                  paddingRight: '0px',
                                                  paddingLeft: '0px',
                                                  paddingTop: 0,
                                                  paddingBottom: 0,
                                                  textAlign: 'center',
                                                  msoLineHeightRule: 'exactly',
                                                  msTextSizeAdjust: '100%',
                                                  WebkitTextSizeAdjust: '100%'
                                                }}
                                                valign='top'
                                              >
                                                <img
                                                  alt=''
                                                  src='https://gallery.mailchimp.com/ae2693d5c4fd62e903167ad5b/images/c6934a8d-a947-41fb-a553-84e01dba3090.png'
                                                  style={{
                                                    maxWidth: '1200px',
                                                    paddingBottom: 0,
                                                    display: 'inline !important',
                                                    verticalAlign: 'bottom',
                                                    border: 0,
                                                    height: 'auto',
                                                    outline: 'none',
                                                    textDecoration: 'none',
                                                    msInterpolationMode: 'bicubic'
                                                  }}
                                                  className='mcnRetinaImage'
                                                  width={600}
                                                  align='middle'
                                                />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table
                                  className='mcnDividerBlock'
                                  style={{
                                    minWidth: '100%',
                                    borderCollapse: 'collapse',
                                    msoTableLspace: '0pt',
                                    msoTableRspace: '0pt',
                                    msTextSizeAdjust: '100%',
                                    WebkitTextSizeAdjust: '100%',
                                    tableLayout: 'fixed !important'
                                  }}
                                  width='100%'
                                  cellSpacing={0}
                                  cellPadding={0}
                                  border={0}
                                >
                                  <tbody className='mcnDividerBlockOuter'>
                                    <tr>
                                      <td
                                        className='mcnDividerBlockInner'
                                        style={{
                                          minWidth: '100%',
                                          padding: '12px 18px',
                                          msoLineHeightRule: 'exactly',
                                          msTextSizeAdjust: '100%',
                                          WebkitTextSizeAdjust: '100%'
                                        }}
                                      >
                                        <table
                                          className='mcnDividerContent'
                                          style={{
                                            minWidth: '100%',
                                            borderTop: '2px none #FFFFFF',
                                            borderCollapse: 'collapse',
                                            msoTableLspace: '0pt',
                                            msoTableRspace: '0pt',
                                            msTextSizeAdjust: '100%',
                                            WebkitTextSizeAdjust: '100%'
                                          }}
                                          width='100%'
                                          cellSpacing={0}
                                          cellPadding={0}
                                          border={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                style={{
                                                  msoLineHeightRule: 'exactly',
                                                  msTextSizeAdjust: '100%',
                                                  WebkitTextSizeAdjust: '100%'
                                                }}
                                              >
                                                <span />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        {/*
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent"
          style="border-bottom-color:none; border-left-color:none;
          border-right-color:none; border-bottom-width:0; border-left-width:0;
          border-right-width:0; margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        {/* [if (gte mso 9)|(IE)]>
                              </td>
                              </tr>
                              </table>
                              <![endif] */}
                      </td>
                    </tr>
                    <tr>
                      <td
                        align='center'
                        valign='top'
                        id='templateBody'
                        style={{
                          background: '#e5edf6 none no-repeat center/cover',
                          msoLineHeightRule: 'exactly',
                          msTextSizeAdjust: '100%',
                          WebkitTextSizeAdjust: '100%',
                          backgroundColor: '#e5edf6',
                          backgroundImage: 'none',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                          backgroundSize: 'cover',
                          borderTop: 0,
                          borderBottom: 0,
                          paddingTop: '9px',
                          paddingBottom: '9px'
                        }}
                      >
                        {/* [if (gte mso 9)|(IE)]>
                              <table align="center"
                              border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">
                              <tr>
                              <td align="center" valign="top" width="600" style="width:600px;">
                              <![endif] */}
                        <table
                          align='center'
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width='100%'
                          className='templateContainer'
                          style={{
                            borderCollapse: 'collapse',
                            msoTableLspace: '0pt',
                            msoTableRspace: '0pt',
                            msTextSizeAdjust: '100%',
                            WebkitTextSizeAdjust: '100%',
                            maxWidth: '600px !important'
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                valign='top'
                                className='bodyContainer'
                                style={{
                                  msoLineHeightRule: 'exactly',
                                  msTextSizeAdjust: '100%',
                                  WebkitTextSizeAdjust: '100%'
                                }}
                              >
                                <table
                                  className='mcnTextBlock'
                                  style={{
                                    minWidth: '100%',
                                    borderCollapse: 'collapse',
                                    msoTableLspace: '0pt',
                                    msoTableRspace: '0pt',
                                    msTextSizeAdjust: '100%',
                                    WebkitTextSizeAdjust: '100%'
                                  }}
                                  width='100%'
                                  cellSpacing={0}
                                  cellPadding={0}
                                  border={0}
                                >
                                  <tbody className='mcnTextBlockOuter'>
                                    <tr>
                                      <td
                                        className='mcnTextBlockInner'
                                        style={{
                                          paddingTop: '9px',
                                          msoLineHeightRule: 'exactly',
                                          msTextSizeAdjust: '100%',
                                          WebkitTextSizeAdjust: '100%'
                                        }}
                                        valign='top'
                                      >
                                        {/* [if mso]>
  <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
  <tr>
  <![endif] */}
                                        {/* [if mso]>
  <td valign="top" width="600" style="width:600px;">
  <![endif] */}
                                        <table
                                          style={{
                                            maxWidth: '100%',
                                            minWidth: '100%',
                                            borderCollapse: 'collapse',
                                            msoTableLspace: '0pt',
                                            msoTableRspace: '0pt',
                                            msTextSizeAdjust: '100%',
                                            WebkitTextSizeAdjust: '100%'
                                          }}
                                          className='mcnTextContentContainer'
                                          width='100%'
                                          cellSpacing={0}
                                          cellPadding={0}
                                          border={0}
                                          align='left'
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                className='mcnTextContent'
                                                style={{
                                                  paddingTop: 0,
                                                  paddingRight: '18px',
                                                  paddingBottom: '9px',
                                                  paddingLeft: '18px',
                                                  msoLineHeightRule: 'exactly',
                                                  msTextSizeAdjust: '100%',
                                                  WebkitTextSizeAdjust: '100%',
                                                  wordBreak: 'break-word',
                                                  color: '#494949',
                                                  fontFamily:
                                                    '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
                                                  fontSize: '16px',
                                                  lineHeight: '150%',
                                                  textAlign: 'left'
                                                }}
                                                valign='top'
                                              >
                                                <p
                                                  style={{
                                                    textAlign: 'justify',
                                                    margin: '10px 0',
                                                    padding: 0,
                                                    msoLineHeightRule: 'exactly',
                                                    msTextSizeAdjust: '100%',
                                                    WebkitTextSizeAdjust: '100%',
                                                    color: '#494949',
                                                    fontFamily:
                                                      '"Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif',
                                                    fontSize: '16px',
                                                    lineHeight: '150%'
                                                  }}
                                                >
                                                  <br />
                                                  Gentile cliente,
                                                  <br />
                                                  <br />
                                                  in questa email puoi trovare
                                                  {getDocumentLabel(documentType, code)} <br />
                                                  <br />
                                                  Nel caso in cui avessi delle domande, puoi rivolgerti alla
                                                  tua{' '}
                                                  <a
                                                    href='https://www.robintur.it/agenzie'
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                    style={{
                                                      msoLineHeightRule: 'exactly',
                                                      msTextSizeAdjust: '100%',
                                                      WebkitTextSizeAdjust: '100%',
                                                      color: '#007C89',
                                                      fontWeight: 'normal',
                                                      textDecoration: 'underline'
                                                    }}
                                                  >
                                                    agenzia di fiducia
                                                  </a>
                                                  , oppure contattare il nostro servizio clienti.
                                                  <br />
                                                  <br />
                                                  Ti ringraziamo per aver scelto Robintur e ti auguriamo buone
                                                  vacanze!
                                                </p>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        {/* [if mso]>
  </td>
  <![endif] */}
                                        {/* [if mso]>
  </tr>
  </table>
  <![endif] */}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table
                                  className='mcnDividerBlock'
                                  style={{
                                    minWidth: '100%',
                                    borderCollapse: 'collapse',
                                    msoTableLspace: '0pt',
                                    msoTableRspace: '0pt',
                                    msTextSizeAdjust: '100%',
                                    WebkitTextSizeAdjust: '100%',
                                    tableLayout: 'fixed !important'
                                  }}
                                  width='100%'
                                  cellSpacing={0}
                                  cellPadding={0}
                                  border={0}
                                >
                                  <tbody className='mcnDividerBlockOuter'>
                                    <tr>
                                      <td
                                        className='mcnDividerBlockInner'
                                        style={{
                                          minWidth: '100%',
                                          padding: '24px 18px',
                                          msoLineHeightRule: 'exactly',
                                          msTextSizeAdjust: '100%',
                                          WebkitTextSizeAdjust: '100%'
                                        }}
                                      >
                                        <table
                                          className='mcnDividerContent'
                                          style={{
                                            minWidth: '100%',
                                            borderTop: '2px none #EAEAEA',
                                            borderCollapse: 'collapse',
                                            msoTableLspace: '0pt',
                                            msoTableRspace: '0pt',
                                            msTextSizeAdjust: '100%',
                                            WebkitTextSizeAdjust: '100%'
                                          }}
                                          width='100%'
                                          cellSpacing={0}
                                          cellPadding={0}
                                          border={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                style={{
                                                  msoLineHeightRule: 'exactly',
                                                  msTextSizeAdjust: '100%',
                                                  WebkitTextSizeAdjust: '100%'
                                                }}
                                              >
                                                <span />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        {/*
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent"
          style="border-bottom-color:none; border-left-color:none; border-right-color:none;
          border-bottom-width:0; border-left-width:0; border-right-width:0; margin-top:0;
          margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                {getBtnSign(documentType, code)}
                                <table
                                  className='mcnButtonBlock'
                                  style={{
                                    minWidth: '100%',
                                    borderCollapse: 'collapse',
                                    msoTableLspace: '0pt',
                                    msoTableRspace: '0pt',
                                    msTextSizeAdjust: '100%',
                                    WebkitTextSizeAdjust: '100%'
                                  }}
                                  width='100%'
                                  cellSpacing={0}
                                  cellPadding={0}
                                  border={0}
                                >
                                  <tbody className='mcnButtonBlockOuter'>
                                    <tr>
                                      <td
                                        style={{
                                          paddingTop: 0,
                                          paddingRight: '18px',
                                          paddingBottom: '18px',
                                          paddingLeft: '18px',
                                          msoLineHeightRule: 'exactly',
                                          msTextSizeAdjust: '100%',
                                          WebkitTextSizeAdjust: '100%'
                                        }}
                                        className='mcnButtonBlockInner'
                                        valign='top'
                                        align='center'
                                      >
                                        <table
                                          className='mcnButtonContentContainer'
                                          style={{
                                            borderCollapse: 'separate !important',
                                            borderRadius: '50px',
                                            backgroundColor: '#EC4541',
                                            msoTableLspace: '0pt',
                                            msoTableRspace: '0pt',
                                            msTextSizeAdjust: '100%',
                                            WebkitTextSizeAdjust: '100%'
                                          }}
                                          cellSpacing={0}
                                          cellPadding={0}
                                          border={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                className='mcnButtonContent'
                                                style={{
                                                  fontFamily:
                                                    '"Roboto", "Helvetica Neue", Helvetica, Arial, sans-serif',
                                                  fontSize: '16px',
                                                  padding: '18px',
                                                  msoLineHeightRule: 'exactly',
                                                  msTextSizeAdjust: '100%',
                                                  WebkitTextSizeAdjust: '100%'
                                                }}
                                                valign='middle'
                                                align='center'
                                              >
                                                <a
                                                  className='mcnButton '
                                                  title='Contatti e supporto'
                                                  href='https://www.robintur.it/contatti-e-supporto?utm_source=Unknown+List&utm_campaign=ce530d79db-EMAIL_CAMPAIGN_2020_11_30_04_45&utm_medium=email&utm_term=0_-ce530d79db-&mc_cid=ce530d79db&mc_eid=[UNIQID]'
                                                  target='_blank'
                                                  rel='noopener noreferrer'
                                                  style={{
                                                    fontWeight: 'normal',
                                                    letterSpacing: 'normal',
                                                    lineHeight: '100%',
                                                    textAlign: 'center',
                                                    textDecoration: 'none',
                                                    color: '#FFFFFF',
                                                    msoLineHeightRule: 'exactly',
                                                    msTextSizeAdjust: '100%',
                                                    WebkitTextSizeAdjust: '100%',
                                                    display: 'block'
                                                  }}
                                                >
                                                  Contatti e supporto
                                                </a>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        {/* [if (gte mso 9)|(IE)]>
                              </td>
                              </tr>
                              </table>
                              <![endif] */}
                      </td>
                    </tr>
                    <tr>
                      <td
                        align='center'
                        valign='top'
                        id='templateFooter'
                        style={{
                          background: '#51536b none no-repeat center/cover',
                          msoLineHeightRule: 'exactly',
                          msTextSizeAdjust: '100%',
                          WebkitTextSizeAdjust: '100%',
                          backgroundColor: '#51536b',
                          backgroundImage: 'none',
                          backgroundRepeat: 'no-repeat',
                          backgroundPosition: 'center',
                          backgroundSize: 'cover',
                          borderTop: 0,
                          borderBottom: 0,
                          paddingTop: '9px',
                          paddingBottom: '9px'
                        }}
                      >
                        {/* [if (gte mso 9)|(IE)]>
                              <table align="center"
                              border="0" cellspacing="0" cellpadding="0" width="600" style="width:600px;">
                              <tr>
                              <td align="center" valign="top" width="600" style="width:600px;">
                              <![endif] */}
                        <table
                          align='center'
                          border={0}
                          cellPadding={0}
                          cellSpacing={0}
                          width='100%'
                          className='templateContainer'
                          style={{
                            borderCollapse: 'collapse',
                            msoTableLspace: '0pt',
                            msoTableRspace: '0pt',
                            msTextSizeAdjust: '100%',
                            WebkitTextSizeAdjust: '100%',
                            maxWidth: '600px !important'
                          }}
                        >
                          <tbody>
                            <tr>
                              <td
                                valign='top'
                                className='footerContainer'
                                style={{
                                  msoLineHeightRule: 'exactly',
                                  msTextSizeAdjust: '100%',
                                  WebkitTextSizeAdjust: '100%'
                                }}
                              >
                                <table
                                  className='mcnImageBlock'
                                  style={{
                                    minWidth: '100%',
                                    borderCollapse: 'collapse',
                                    msoTableLspace: '0pt',
                                    msoTableRspace: '0pt',
                                    msTextSizeAdjust: '100%',
                                    WebkitTextSizeAdjust: '100%'
                                  }}
                                  width='100%'
                                  cellSpacing={0}
                                  cellPadding={0}
                                  border={0}
                                >
                                  <tbody className='mcnImageBlockOuter'>
                                    <tr>
                                      <td
                                        style={{
                                          padding: '9px',
                                          msoLineHeightRule: 'exactly',
                                          msTextSizeAdjust: '100%',
                                          WebkitTextSizeAdjust: '100%'
                                        }}
                                        className='mcnImageBlockInner'
                                        valign='top'
                                      >
                                        <table
                                          className='mcnImageContentContainer'
                                          style={{
                                            minWidth: '100%',
                                            borderCollapse: 'collapse',
                                            msoTableLspace: '0pt',
                                            msoTableRspace: '0pt',
                                            msTextSizeAdjust: '100%',
                                            WebkitTextSizeAdjust: '100%'
                                          }}
                                          width='100%'
                                          cellSpacing={0}
                                          cellPadding={0}
                                          border={0}
                                          align='left'
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                className='mcnImageContent'
                                                style={{
                                                  paddingRight: '9px',
                                                  paddingLeft: '9px',
                                                  paddingTop: 0,
                                                  paddingBottom: 0,
                                                  textAlign: 'center',
                                                  msoLineHeightRule: 'exactly',
                                                  msTextSizeAdjust: '100%',
                                                  WebkitTextSizeAdjust: '100%'
                                                }}
                                                valign='top'
                                              >
                                                <img
                                                  alt=''
                                                  src='https://gallery.mailchimp.com/b87176bc980aa00bc8dc94092/images/62e6128c-6d27-4ae5-8c7c-c6f75ab4676d.png'
                                                  style={{
                                                    maxWidth: '1200px',
                                                    paddingBottom: 0,
                                                    display: 'inline !important',
                                                    verticalAlign: 'bottom',
                                                    border: 0,
                                                    height: 'auto',
                                                    outline: 'none',
                                                    textDecoration: 'none',
                                                    msInterpolationMode: 'bicubic'
                                                  }}
                                                  className='mcnImage'
                                                  width={564}
                                                  align='middle'
                                                />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table
                                  className='mcnFollowBlock'
                                  style={{
                                    minWidth: '100%',
                                    borderCollapse: 'collapse',
                                    msoTableLspace: '0pt',
                                    msoTableRspace: '0pt',
                                    msTextSizeAdjust: '100%',
                                    WebkitTextSizeAdjust: '100%'
                                  }}
                                  width='100%'
                                  cellSpacing={0}
                                  cellPadding={0}
                                  border={0}
                                >
                                  <tbody className='mcnFollowBlockOuter'>
                                    <tr>
                                      <td
                                        style={{
                                          padding: '9px',
                                          msoLineHeightRule: 'exactly',
                                          msTextSizeAdjust: '100%',
                                          WebkitTextSizeAdjust: '100%'
                                        }}
                                        className='mcnFollowBlockInner'
                                        valign='top'
                                        align='center'
                                      >
                                        <table
                                          className='mcnFollowContentContainer'
                                          style={{
                                            minWidth: '100%',
                                            borderCollapse: 'collapse',
                                            msoTableLspace: '0pt',
                                            msoTableRspace: '0pt',
                                            msTextSizeAdjust: '100%',
                                            WebkitTextSizeAdjust: '100%'
                                          }}
                                          width='100%'
                                          cellSpacing={0}
                                          cellPadding={0}
                                          border={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                style={{
                                                  paddingLeft: '9px',
                                                  paddingRight: '9px',
                                                  msoLineHeightRule: 'exactly',
                                                  msTextSizeAdjust: '100%',
                                                  WebkitTextSizeAdjust: '100%'
                                                }}
                                                align='center'
                                              >
                                                <table
                                                  style={{
                                                    minWidth: '100%',
                                                    borderCollapse: 'collapse',
                                                    msoTableLspace: '0pt',
                                                    msoTableRspace: '0pt',
                                                    msTextSizeAdjust: '100%',
                                                    WebkitTextSizeAdjust: '100%'
                                                  }}
                                                  className='mcnFollowContent'
                                                  width='100%'
                                                  cellSpacing={0}
                                                  cellPadding={0}
                                                  border={0}
                                                >
                                                  <tbody>
                                                    <tr>
                                                      <td
                                                        style={{
                                                          paddingTop: '9px',
                                                          paddingRight: '9px',
                                                          paddingLeft: '9px',
                                                          msoLineHeightRule: 'exactly',
                                                          msTextSizeAdjust: '100%',
                                                          WebkitTextSizeAdjust: '100%'
                                                        }}
                                                        valign='top'
                                                        align='center'
                                                      >
                                                        <table
                                                          cellSpacing={0}
                                                          cellPadding={0}
                                                          border={0}
                                                          align='center'
                                                          style={{
                                                            borderCollapse: 'collapse',
                                                            msoTableLspace: '0pt',
                                                            msoTableRspace: '0pt',
                                                            msTextSizeAdjust: '100%',
                                                            WebkitTextSizeAdjust: '100%'
                                                          }}
                                                        >
                                                          <tbody>
                                                            <tr>
                                                              <td
                                                                valign='top'
                                                                align='center'
                                                                style={{
                                                                  msoLineHeightRule: 'exactly',
                                                                  msTextSizeAdjust: '100%',
                                                                  WebkitTextSizeAdjust: '100%'
                                                                }}
                                                              >
                                                                {/* [if mso]>
                              <table align="center" border="0" cellspacing="0" cellpadding="0">
                              <tr>
                              <![endif] */}
                                                                {/* [if mso]>
                                  <td align="center" valign="top">
                                  <![endif] */}
                                                                <table
                                                                  style={{
                                                                    display: 'inline',
                                                                    borderCollapse: 'collapse',
                                                                    msoTableLspace: '0pt',
                                                                    msoTableRspace: '0pt',
                                                                    msTextSizeAdjust: '100%',
                                                                    WebkitTextSizeAdjust: '100%'
                                                                  }}
                                                                  cellSpacing={0}
                                                                  cellPadding={0}
                                                                  border={0}
                                                                  align='left'
                                                                >
                                                                  <tbody>
                                                                    <tr>
                                                                      <td
                                                                        style={{
                                                                          paddingRight: '10px',
                                                                          paddingBottom: '9px',
                                                                          msoLineHeightRule: 'exactly',
                                                                          msTextSizeAdjust: '100%',
                                                                          WebkitTextSizeAdjust: '100%'
                                                                        }}
                                                                        className='mcnFollowContentItemContainer'
                                                                        valign='top'
                                                                      >
                                                                        <table
                                                                          className='mcnFollowContentItem'
                                                                          width='100%'
                                                                          cellSpacing={0}
                                                                          cellPadding={0}
                                                                          border={0}
                                                                          style={{
                                                                            borderCollapse: 'collapse',
                                                                            msoTableLspace: '0pt',
                                                                            msoTableRspace: '0pt',
                                                                            msTextSizeAdjust: '100%',
                                                                            WebkitTextSizeAdjust: '100%'
                                                                          }}
                                                                        >
                                                                          <tbody>
                                                                            <tr>
                                                                              <td
                                                                                style={{
                                                                                  paddingTop: '5px',
                                                                                  paddingRight: '10px',
                                                                                  paddingBottom: '5px',
                                                                                  paddingLeft: '9px',
                                                                                  msoLineHeightRule:
                                                                                    'exactly',
                                                                                  msTextSizeAdjust: '100%',
                                                                                  WebkitTextSizeAdjust: '100%'
                                                                                }}
                                                                                valign='middle'
                                                                                align='left'
                                                                              >
                                                                                <table
                                                                                  width
                                                                                  cellSpacing={0}
                                                                                  cellPadding={0}
                                                                                  border={0}
                                                                                  align='left'
                                                                                  style={{
                                                                                    borderCollapse:
                                                                                      'collapse',
                                                                                    msoTableLspace: '0pt',
                                                                                    msoTableRspace: '0pt',
                                                                                    msTextSizeAdjust: '100%',
                                                                                    WebkitTextSizeAdjust:
                                                                                      '100%'
                                                                                  }}
                                                                                >
                                                                                  <tbody>
                                                                                    <tr>
                                                                                      <td
                                                                                        className='mcnFollowIconContent'
                                                                                        width={24}
                                                                                        valign='middle'
                                                                                        align='center'
                                                                                        style={{
                                                                                          msoLineHeightRule:
                                                                                            'exactly',
                                                                                          msTextSizeAdjust:
                                                                                            '100%',
                                                                                          WebkitTextSizeAdjust:
                                                                                            '100%'
                                                                                        }}
                                                                                      >
                                                                                        <a
                                                                                          href='https://www.facebook.com/RobinturTravelGroup/?utm_source=Unknown+List&utm_campaign=ce530d79db-EMAIL_CAMPAIGN_2020_11_30_04_45&utm_medium=email&utm_term=0_-ce530d79db-&mc_cid=ce530d79db&mc_eid=[UNIQID]'
                                                                                          target='_blank'
                                                                                          rel='noopener noreferrer'
                                                                                          style={{
                                                                                            msoLineHeightRule:
                                                                                              'exactly',
                                                                                            msTextSizeAdjust:
                                                                                              '100%',
                                                                                            WebkitTextSizeAdjust:
                                                                                              '100%'
                                                                                          }}
                                                                                        >
                                                                                          <img
                                                                                            src='https://cdn-images.mailchimp.com/icons/social-block-v2/outline-light-facebook-48.png'
                                                                                            alt='Facebook'
                                                                                            style={{
                                                                                              display:
                                                                                                'block',
                                                                                              border: 0,
                                                                                              height: 'auto',
                                                                                              outline: 'none',
                                                                                              textDecoration:
                                                                                                'none',
                                                                                              msInterpolationMode:
                                                                                                'bicubic'
                                                                                            }}
                                                                                            className
                                                                                            width={24}
                                                                                            height={24}
                                                                                          />
                                                                                        </a>
                                                                                      </td>
                                                                                    </tr>
                                                                                  </tbody>
                                                                                </table>
                                                                              </td>
                                                                            </tr>
                                                                          </tbody>
                                                                        </table>
                                                                      </td>
                                                                    </tr>
                                                                  </tbody>
                                                                </table>
                                                                {/* [if mso]>
                                  </td>
                                  <![endif] */}
                                                                {/* [if mso]>
                                  <td align="center" valign="top">
                                  <![endif] */}
                                                                <table
                                                                  style={{
                                                                    display: 'inline',
                                                                    borderCollapse: 'collapse',
                                                                    msoTableLspace: '0pt',
                                                                    msoTableRspace: '0pt',
                                                                    msTextSizeAdjust: '100%',
                                                                    WebkitTextSizeAdjust: '100%'
                                                                  }}
                                                                  cellSpacing={0}
                                                                  cellPadding={0}
                                                                  border={0}
                                                                  align='left'
                                                                >
                                                                  <tbody>
                                                                    <tr>
                                                                      <td
                                                                        style={{
                                                                          paddingRight: '10px',
                                                                          paddingBottom: '9px',
                                                                          msoLineHeightRule: 'exactly',
                                                                          msTextSizeAdjust: '100%',
                                                                          WebkitTextSizeAdjust: '100%'
                                                                        }}
                                                                        className='mcnFollowContentItemContainer'
                                                                        valign='top'
                                                                      >
                                                                        <table
                                                                          className='mcnFollowContentItem'
                                                                          width='100%'
                                                                          cellSpacing={0}
                                                                          cellPadding={0}
                                                                          border={0}
                                                                          style={{
                                                                            borderCollapse: 'collapse',
                                                                            msoTableLspace: '0pt',
                                                                            msoTableRspace: '0pt',
                                                                            msTextSizeAdjust: '100%',
                                                                            WebkitTextSizeAdjust: '100%'
                                                                          }}
                                                                        >
                                                                          <tbody>
                                                                            <tr>
                                                                              <td
                                                                                style={{
                                                                                  paddingTop: '5px',
                                                                                  paddingRight: '10px',
                                                                                  paddingBottom: '5px',
                                                                                  paddingLeft: '9px',
                                                                                  msoLineHeightRule:
                                                                                    'exactly',
                                                                                  msTextSizeAdjust: '100%',
                                                                                  WebkitTextSizeAdjust: '100%'
                                                                                }}
                                                                                valign='middle'
                                                                                align='left'
                                                                              >
                                                                                <table
                                                                                  width
                                                                                  cellSpacing={0}
                                                                                  cellPadding={0}
                                                                                  border={0}
                                                                                  align='left'
                                                                                  style={{
                                                                                    borderCollapse:
                                                                                      'collapse',
                                                                                    msoTableLspace: '0pt',
                                                                                    msoTableRspace: '0pt',
                                                                                    msTextSizeAdjust: '100%',
                                                                                    WebkitTextSizeAdjust:
                                                                                      '100%'
                                                                                  }}
                                                                                >
                                                                                  <tbody>
                                                                                    <tr>
                                                                                      <td
                                                                                        className='mcnFollowIconContent'
                                                                                        width={24}
                                                                                        valign='middle'
                                                                                        align='center'
                                                                                        style={{
                                                                                          msoLineHeightRule:
                                                                                            'exactly',
                                                                                          msTextSizeAdjust:
                                                                                            '100%',
                                                                                          WebkitTextSizeAdjust:
                                                                                            '100%'
                                                                                        }}
                                                                                      >
                                                                                        <a
                                                                                          href='https://www.instagram.com/robinturtravelgroup/?utm_source=Unknown+List&utm_campaign=ce530d79db-EMAIL_CAMPAIGN_2020_11_30_04_45&utm_medium=email&utm_term=0_-ce530d79db-&mc_cid=ce530d79db&mc_eid=[UNIQID]'
                                                                                          target='_blank'
                                                                                          rel='noopener noreferrer'
                                                                                          style={{
                                                                                            msoLineHeightRule:
                                                                                              'exactly',
                                                                                            msTextSizeAdjust:
                                                                                              '100%',
                                                                                            WebkitTextSizeAdjust:
                                                                                              '100%'
                                                                                          }}
                                                                                        >
                                                                                          <img
                                                                                            src='https://cdn-images.mailchimp.com/icons/social-block-v2/outline-light-instagram-48.png'
                                                                                            alt='Instagram'
                                                                                            style={{
                                                                                              display:
                                                                                                'block',
                                                                                              border: 0,
                                                                                              height: 'auto',
                                                                                              outline: 'none',
                                                                                              textDecoration:
                                                                                                'none',
                                                                                              msInterpolationMode:
                                                                                                'bicubic'
                                                                                            }}
                                                                                            className
                                                                                            width={24}
                                                                                            height={24}
                                                                                          />
                                                                                        </a>
                                                                                      </td>
                                                                                    </tr>
                                                                                  </tbody>
                                                                                </table>
                                                                              </td>
                                                                            </tr>
                                                                          </tbody>
                                                                        </table>
                                                                      </td>
                                                                    </tr>
                                                                  </tbody>
                                                                </table>
                                                                {/* [if mso]>
                                  </td>
                                  <![endif] */}
                                                                {/* [if mso]>
                                  <td align="center" valign="top">
                                  <![endif] */}
                                                                <table
                                                                  style={{
                                                                    display: 'inline',
                                                                    borderCollapse: 'collapse',
                                                                    msoTableLspace: '0pt',
                                                                    msoTableRspace: '0pt',
                                                                    msTextSizeAdjust: '100%',
                                                                    WebkitTextSizeAdjust: '100%'
                                                                  }}
                                                                  cellSpacing={0}
                                                                  cellPadding={0}
                                                                  border={0}
                                                                  align='left'
                                                                >
                                                                  <tbody>
                                                                    <tr>
                                                                      <td
                                                                        style={{
                                                                          paddingRight: '10px',
                                                                          paddingBottom: '9px',
                                                                          msoLineHeightRule: 'exactly',
                                                                          msTextSizeAdjust: '100%',
                                                                          WebkitTextSizeAdjust: '100%'
                                                                        }}
                                                                        className='mcnFollowContentItemContainer'
                                                                        valign='top'
                                                                      >
                                                                        <table
                                                                          className='mcnFollowContentItem'
                                                                          width='100%'
                                                                          cellSpacing={0}
                                                                          cellPadding={0}
                                                                          border={0}
                                                                          style={{
                                                                            borderCollapse: 'collapse',
                                                                            msoTableLspace: '0pt',
                                                                            msoTableRspace: '0pt',
                                                                            msTextSizeAdjust: '100%',
                                                                            WebkitTextSizeAdjust: '100%'
                                                                          }}
                                                                        >
                                                                          <tbody>
                                                                            <tr>
                                                                              <td
                                                                                style={{
                                                                                  paddingTop: '5px',
                                                                                  paddingRight: '10px',
                                                                                  paddingBottom: '5px',
                                                                                  paddingLeft: '9px',
                                                                                  msoLineHeightRule:
                                                                                    'exactly',
                                                                                  msTextSizeAdjust: '100%',
                                                                                  WebkitTextSizeAdjust: '100%'
                                                                                }}
                                                                                valign='middle'
                                                                                align='left'
                                                                              >
                                                                                <table
                                                                                  width
                                                                                  cellSpacing={0}
                                                                                  cellPadding={0}
                                                                                  border={0}
                                                                                  align='left'
                                                                                  style={{
                                                                                    borderCollapse:
                                                                                      'collapse',
                                                                                    msoTableLspace: '0pt',
                                                                                    msoTableRspace: '0pt',
                                                                                    msTextSizeAdjust: '100%',
                                                                                    WebkitTextSizeAdjust:
                                                                                      '100%'
                                                                                  }}
                                                                                >
                                                                                  <tbody>
                                                                                    <tr>
                                                                                      <td
                                                                                        className='mcnFollowIconContent'
                                                                                        width={24}
                                                                                        valign='middle'
                                                                                        align='center'
                                                                                        style={{
                                                                                          msoLineHeightRule:
                                                                                            'exactly',
                                                                                          msTextSizeAdjust:
                                                                                            '100%',
                                                                                          WebkitTextSizeAdjust:
                                                                                            '100%'
                                                                                        }}
                                                                                      >
                                                                                        <a
                                                                                          href='https://twitter.com/RobinturTravel?utm_source=Unknown+List&utm_campaign=ce530d79db-EMAIL_CAMPAIGN_2020_11_30_04_45&utm_medium=email&utm_term=0_-ce530d79db-&mc_cid=ce530d79db&mc_eid=[UNIQID]'
                                                                                          target='_blank'
                                                                                          rel='noopener noreferrer'
                                                                                          style={{
                                                                                            msoLineHeightRule:
                                                                                              'exactly',
                                                                                            msTextSizeAdjust:
                                                                                              '100%',
                                                                                            WebkitTextSizeAdjust:
                                                                                              '100%'
                                                                                          }}
                                                                                        >
                                                                                          <img
                                                                                            src='https://cdn-images.mailchimp.com/icons/social-block-v2/outline-light-twitter-48.png'
                                                                                            alt='Twitter'
                                                                                            style={{
                                                                                              display:
                                                                                                'block',
                                                                                              border: 0,
                                                                                              height: 'auto',
                                                                                              outline: 'none',
                                                                                              textDecoration:
                                                                                                'none',
                                                                                              msInterpolationMode:
                                                                                                'bicubic'
                                                                                            }}
                                                                                            className
                                                                                            width={24}
                                                                                            height={24}
                                                                                          />
                                                                                        </a>
                                                                                      </td>
                                                                                    </tr>
                                                                                  </tbody>
                                                                                </table>
                                                                              </td>
                                                                            </tr>
                                                                          </tbody>
                                                                        </table>
                                                                      </td>
                                                                    </tr>
                                                                  </tbody>
                                                                </table>
                                                                {/* [if mso]>
                                  </td>
                                  <![endif] */}
                                                                {/* [if mso]>
                                  <td align="center" valign="top">
                                  <![endif] */}
                                                                <table
                                                                  style={{
                                                                    display: 'inline',
                                                                    borderCollapse: 'collapse',
                                                                    msoTableLspace: '0pt',
                                                                    msoTableRspace: '0pt',
                                                                    msTextSizeAdjust: '100%',
                                                                    WebkitTextSizeAdjust: '100%'
                                                                  }}
                                                                  cellSpacing={0}
                                                                  cellPadding={0}
                                                                  border={0}
                                                                  align='left'
                                                                >
                                                                  <tbody>
                                                                    <tr>
                                                                      <td
                                                                        style={{
                                                                          paddingRight: '10px',
                                                                          paddingBottom: '9px',
                                                                          msoLineHeightRule: 'exactly',
                                                                          msTextSizeAdjust: '100%',
                                                                          WebkitTextSizeAdjust: '100%'
                                                                        }}
                                                                        className='mcnFollowContentItemContainer'
                                                                        valign='top'
                                                                      >
                                                                        <table
                                                                          className='mcnFollowContentItem'
                                                                          width='100%'
                                                                          cellSpacing={0}
                                                                          cellPadding={0}
                                                                          border={0}
                                                                          style={{
                                                                            borderCollapse: 'collapse',
                                                                            msoTableLspace: '0pt',
                                                                            msoTableRspace: '0pt',
                                                                            msTextSizeAdjust: '100%',
                                                                            WebkitTextSizeAdjust: '100%'
                                                                          }}
                                                                        >
                                                                          <tbody>
                                                                            <tr>
                                                                              <td
                                                                                style={{
                                                                                  paddingTop: '5px',
                                                                                  paddingRight: '10px',
                                                                                  paddingBottom: '5px',
                                                                                  paddingLeft: '9px',
                                                                                  msoLineHeightRule:
                                                                                    'exactly',
                                                                                  msTextSizeAdjust: '100%',
                                                                                  WebkitTextSizeAdjust: '100%'
                                                                                }}
                                                                                valign='middle'
                                                                                align='left'
                                                                              >
                                                                                <table
                                                                                  width
                                                                                  cellSpacing={0}
                                                                                  cellPadding={0}
                                                                                  border={0}
                                                                                  align='left'
                                                                                  style={{
                                                                                    borderCollapse:
                                                                                      'collapse',
                                                                                    msoTableLspace: '0pt',
                                                                                    msoTableRspace: '0pt',
                                                                                    msTextSizeAdjust: '100%',
                                                                                    WebkitTextSizeAdjust:
                                                                                      '100%'
                                                                                  }}
                                                                                >
                                                                                  <tbody>
                                                                                    <tr>
                                                                                      <td
                                                                                        className='mcnFollowIconContent'
                                                                                        width={24}
                                                                                        valign='middle'
                                                                                        align='center'
                                                                                        style={{
                                                                                          msoLineHeightRule:
                                                                                            'exactly',
                                                                                          msTextSizeAdjust:
                                                                                            '100%',
                                                                                          WebkitTextSizeAdjust:
                                                                                            '100%'
                                                                                        }}
                                                                                      >
                                                                                        <a
                                                                                          href='https://www.linkedin.com/company/robintur/?utm_source=Unknown+List&utm_campaign=ce530d79db-EMAIL_CAMPAIGN_2020_11_30_04_45&utm_medium=email&utm_term=0_-ce530d79db-&mc_cid=ce530d79db&mc_eid=[UNIQID]'
                                                                                          target='_blank'
                                                                                          rel='noopener noreferrer'
                                                                                          style={{
                                                                                            msoLineHeightRule:
                                                                                              'exactly',
                                                                                            msTextSizeAdjust:
                                                                                              '100%',
                                                                                            WebkitTextSizeAdjust:
                                                                                              '100%'
                                                                                          }}
                                                                                        >
                                                                                          <img
                                                                                            src='https://cdn-images.mailchimp.com/icons/social-block-v2/outline-light-linkedin-48.png'
                                                                                            alt='LinkedIn'
                                                                                            style={{
                                                                                              display:
                                                                                                'block',
                                                                                              border: 0,
                                                                                              height: 'auto',
                                                                                              outline: 'none',
                                                                                              textDecoration:
                                                                                                'none',
                                                                                              msInterpolationMode:
                                                                                                'bicubic'
                                                                                            }}
                                                                                            className
                                                                                            width={24}
                                                                                            height={24}
                                                                                          />
                                                                                        </a>
                                                                                      </td>
                                                                                    </tr>
                                                                                  </tbody>
                                                                                </table>
                                                                              </td>
                                                                            </tr>
                                                                          </tbody>
                                                                        </table>
                                                                      </td>
                                                                    </tr>
                                                                  </tbody>
                                                                </table>
                                                                {/* [if mso]>
                                  </td>
                                  <![endif] */}
                                                                {/* [if mso]>
                                  <td align="center" valign="top">
                                  <![endif] */}
                                                                <table
                                                                  style={{
                                                                    display: 'inline',
                                                                    borderCollapse: 'collapse',
                                                                    msoTableLspace: '0pt',
                                                                    msoTableRspace: '0pt',
                                                                    msTextSizeAdjust: '100%',
                                                                    WebkitTextSizeAdjust: '100%'
                                                                  }}
                                                                  cellSpacing={0}
                                                                  cellPadding={0}
                                                                  border={0}
                                                                  align='left'
                                                                >
                                                                  <tbody>
                                                                    <tr>
                                                                      <td
                                                                        style={{
                                                                          paddingRight: 0,
                                                                          paddingBottom: '9px',
                                                                          msoLineHeightRule: 'exactly',
                                                                          msTextSizeAdjust: '100%',
                                                                          WebkitTextSizeAdjust: '100%'
                                                                        }}
                                                                        className='mcnFollowContentItemContainer'
                                                                        valign='top'
                                                                      >
                                                                        <table
                                                                          className='mcnFollowContentItem'
                                                                          width='100%'
                                                                          cellSpacing={0}
                                                                          cellPadding={0}
                                                                          border={0}
                                                                          style={{
                                                                            borderCollapse: 'collapse',
                                                                            msoTableLspace: '0pt',
                                                                            msoTableRspace: '0pt',
                                                                            msTextSizeAdjust: '100%',
                                                                            WebkitTextSizeAdjust: '100%'
                                                                          }}
                                                                        >
                                                                          <tbody>
                                                                            <tr>
                                                                              <td
                                                                                style={{
                                                                                  paddingTop: '5px',
                                                                                  paddingRight: '10px',
                                                                                  paddingBottom: '5px',
                                                                                  paddingLeft: '9px',
                                                                                  msoLineHeightRule:
                                                                                    'exactly',
                                                                                  msTextSizeAdjust: '100%',
                                                                                  WebkitTextSizeAdjust: '100%'
                                                                                }}
                                                                                valign='middle'
                                                                                align='left'
                                                                              >
                                                                                <table
                                                                                  width
                                                                                  cellSpacing={0}
                                                                                  cellPadding={0}
                                                                                  border={0}
                                                                                  align='left'
                                                                                  style={{
                                                                                    borderCollapse:
                                                                                      'collapse',
                                                                                    msoTableLspace: '0pt',
                                                                                    msoTableRspace: '0pt',
                                                                                    msTextSizeAdjust: '100%',
                                                                                    WebkitTextSizeAdjust:
                                                                                      '100%'
                                                                                  }}
                                                                                >
                                                                                  <tbody>
                                                                                    <tr>
                                                                                      <td
                                                                                        className='mcnFollowIconContent'
                                                                                        width={24}
                                                                                        valign='middle'
                                                                                        align='center'
                                                                                        style={{
                                                                                          msoLineHeightRule:
                                                                                            'exactly',
                                                                                          msTextSizeAdjust:
                                                                                            '100%',
                                                                                          WebkitTextSizeAdjust:
                                                                                            '100%'
                                                                                        }}
                                                                                      >
                                                                                        <a
                                                                                          href='https://www.robintur.it/?utm_source=Unknown+List&utm_campaign=ce530d79db-EMAIL_CAMPAIGN_2020_11_30_04_45&utm_medium=email&utm_term=0_-ce530d79db-&mc_cid=ce530d79db&mc_eid=[UNIQID]'
                                                                                          target='_blank'
                                                                                          rel='noopener noreferrer'
                                                                                          style={{
                                                                                            msoLineHeightRule:
                                                                                              'exactly',
                                                                                            msTextSizeAdjust:
                                                                                              '100%',
                                                                                            WebkitTextSizeAdjust:
                                                                                              '100%'
                                                                                          }}
                                                                                        >
                                                                                          <img
                                                                                            src='https://cdn-images.mailchimp.com/icons/social-block-v2/outline-light-link-48.png'
                                                                                            alt='Website'
                                                                                            style={{
                                                                                              display:
                                                                                                'block',
                                                                                              border: 0,
                                                                                              height: 'auto',
                                                                                              outline: 'none',
                                                                                              textDecoration:
                                                                                                'none',
                                                                                              msInterpolationMode:
                                                                                                'bicubic'
                                                                                            }}
                                                                                            className
                                                                                            width={24}
                                                                                            height={24}
                                                                                          />
                                                                                        </a>
                                                                                      </td>
                                                                                    </tr>
                                                                                  </tbody>
                                                                                </table>
                                                                              </td>
                                                                            </tr>
                                                                          </tbody>
                                                                        </table>
                                                                      </td>
                                                                    </tr>
                                                                  </tbody>
                                                                </table>
                                                                {/* [if mso]>
                                  </td>
                                  <![endif] */}
                                                                {/* [if mso]>
                              </tr>
                              </table>
                              <![endif] */}
                                                              </td>
                                                            </tr>
                                                          </tbody>
                                                        </table>
                                                      </td>
                                                    </tr>
                                                  </tbody>
                                                </table>
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table
                                  className='mcnDividerBlock'
                                  style={{
                                    minWidth: '100%',
                                    borderCollapse: 'collapse',
                                    msoTableLspace: '0pt',
                                    msoTableRspace: '0pt',
                                    msTextSizeAdjust: '100%',
                                    WebkitTextSizeAdjust: '100%',
                                    tableLayout: 'fixed !important'
                                  }}
                                  width='100%'
                                  cellSpacing={0}
                                  cellPadding={0}
                                  border={0}
                                >
                                  <tbody className='mcnDividerBlockOuter'>
                                    <tr>
                                      <td
                                        className='mcnDividerBlockInner'
                                        style={{
                                          minWidth: '100%',
                                          padding: '10px 18px 25px',
                                          msoLineHeightRule: 'exactly',
                                          msTextSizeAdjust: '100%',
                                          WebkitTextSizeAdjust: '100%'
                                        }}
                                      >
                                        <table
                                          className='mcnDividerContent'
                                          style={{
                                            minWidth: '100%',
                                            borderTop: '2px solid #EEEEEE',
                                            borderCollapse: 'collapse',
                                            msoTableLspace: '0pt',
                                            msoTableRspace: '0pt',
                                            msTextSizeAdjust: '100%',
                                            WebkitTextSizeAdjust: '100%'
                                          }}
                                          width='100%'
                                          cellSpacing={0}
                                          cellPadding={0}
                                          border={0}
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                style={{
                                                  msoLineHeightRule: 'exactly',
                                                  msTextSizeAdjust: '100%',
                                                  WebkitTextSizeAdjust: '100%'
                                                }}
                                              >
                                                <span />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        {/*
          <td class="mcnDividerBlockInner" style="padding: 18px;">
          <hr class="mcnDividerContent"
          style="border-bottom-color:none; border-left-color:none; border-right-color:none;
          border-bottom-width:0; border-left-width:0; border-right-width:0;
          margin-top:0; margin-right:0; margin-bottom:0; margin-left:0;" />
*/}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <table
                                  className='mcnTextBlock'
                                  style={{
                                    minWidth: '100%',
                                    borderCollapse: 'collapse',
                                    msoTableLspace: '0pt',
                                    msoTableRspace: '0pt',
                                    msTextSizeAdjust: '100%',
                                    WebkitTextSizeAdjust: '100%'
                                  }}
                                  width='100%'
                                  cellSpacing={0}
                                  cellPadding={0}
                                  border={0}
                                >
                                  <tbody className='mcnTextBlockOuter'>
                                    <tr>
                                      <td
                                        className='mcnTextBlockInner'
                                        style={{
                                          paddingTop: '9px',
                                          msoLineHeightRule: 'exactly',
                                          msTextSizeAdjust: '100%',
                                          WebkitTextSizeAdjust: '100%'
                                        }}
                                        valign='top'
                                      >
                                        {/* [if mso]>
  <table align="left" border="0" cellspacing="0" cellpadding="0" width="100%" style="width:100%;">
  <tr>
  <![endif] */}
                                        {/* [if mso]>
  <td valign="top" width="600" style="width:600px;">
  <![endif] */}
                                        <table
                                          style={{
                                            maxWidth: '100%',
                                            minWidth: '100%',
                                            borderCollapse: 'collapse',
                                            msoTableLspace: '0pt',
                                            msoTableRspace: '0pt',
                                            msTextSizeAdjust: '100%',
                                            WebkitTextSizeAdjust: '100%'
                                          }}
                                          className='mcnTextContentContainer'
                                          width='100%'
                                          cellSpacing={0}
                                          cellPadding={0}
                                          border={0}
                                          align='left'
                                        >
                                          <tbody>
                                            <tr>
                                              <td
                                                className='mcnTextContent'
                                                style={{
                                                  paddingTop: 0,
                                                  paddingRight: '18px',
                                                  paddingBottom: '9px',
                                                  paddingLeft: '18px',
                                                  msoLineHeightRule: 'exactly',
                                                  msTextSizeAdjust: '100%',
                                                  WebkitTextSizeAdjust: '100%',
                                                  wordBreak: 'break-word',
                                                  color: '#ffffff',
                                                  fontFamily: 'Helvetica',
                                                  fontSize: '12px',
                                                  lineHeight: '150%',
                                                  textAlign: 'center'
                                                }}
                                                valign='top'
                                              >
                                                <em>Copyright © 2020 Tutti i diritti riservati.</em>
                                                <br />
                                              </td>
                                            </tr>
                                          </tbody>
                                        </table>
                                        {/* [if mso]>
  </td>
  <![endif] */}
                                        {/* [if mso]>
  </tr>
  </table>
  <![endif] */}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        {/* [if (gte mso 9)|(IE)]>
                              </td>
                              </tr>
                              </table>
                              <![endif] */}
                      </td>
                    </tr>
                  </tbody>
                </table>
                {/* // END TEMPLATE */}
              </td>
            </tr>
          </tbody>
        </table>
      </center>
    </div>
  )
}
